export default __webpack_public_path__ + "static/media/article_2.bfdb5883.png";